import { Directive, TemplateRef } from "@angular/core";

/**
 * This structural directive is used to mark a <ng-template> in a TabItemComponent.
 * If this directive is used then the title of the TabItemComponent can be the one present in the <ng-template>.
 *
 * Usage with <h-tab-item> component :
 *
 * ```
 * <h-tab-list>
 *   <h-tab-item>
 *     <ng-template [hTabTitle]>
 *       <p>Custom Title Content</p>
 *     </ng-template>
 *   <h-tab-item>
 * </h-tab-list>
 * ```
 */
@Directive({
    selector: "[hTabTitle]",
    standalone: true,
})
export class TabTitleDirective {
    constructor(public templateReference: TemplateRef<any>) {}
}
